module.exports = __webpack_public_path__ + "img/logo-splash.53b5bc69.png";